import { render, staticRenderFns } from "./submitWelfareApprove.vue?vue&type=template&id=198a6f1d&scoped=true&"
import script from "./submitWelfareApprove.vue?vue&type=script&lang=js&"
export * from "./submitWelfareApprove.vue?vue&type=script&lang=js&"
import style0 from "./submitWelfareApprove.vue?vue&type=style&index=0&id=198a6f1d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198a6f1d",
  null
  
)

export default component.exports